export default "__VITE_ASSET__tL6q9GFY__"